import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { createClient, ensureUserProfileAndKey } from '@/lib/supabase-client'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const [loading, setLoading] = useState(true)
  const [authenticated, setAuthenticated] = useState(false)
  const supabase = createClient()

  useEffect(() => {
    checkAuth()
  }, [])

  const checkAuth = async () => {
    const { data: { session } } = await supabase.auth.getSession()
    if (session) {
      // Self-healing check (only runs once per session per user to keep it fast)
      const sessionKey = `gistmag_profile_ensured_${session.user.id}`
      if (!sessionStorage.getItem(sessionKey)) {
        await ensureUserProfileAndKey(
          supabase,
          session.user.id,
          session.user.email || '',
          session.user.user_metadata?.name
        )
        sessionStorage.setItem(sessionKey, 'true')
      }
      setAuthenticated(true)
    } else {
      setAuthenticated(false)
    }
    setLoading(false)
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-white dark:bg-slate-900 flex items-center justify-center">
        <div className="text-center animate-fade-in">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 dark:border-primary-400"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    )
  }

  if (!authenticated) {
    return <Navigate to="/auth/login" replace />
  }

  return <>{children}</>
}

